// The concierge writes plain chat text (Oct 17, Felipe: the chat showed "**"
// everywhere). Models drift into markdown and long dashes anyway, so every
// reply is cleaned before it is stored (renter-chat-concierge, through the
// Deno mirror supabase/functions/_shared/chatText.ts) and again when shown,
// for replies saved before the fix. src/test/chatText.test.ts runs the same
// cases against both.
export function plainChatText(text: string): string {
  return text
    .replace(/^([ \t]*)[*\u2022][ \t]+/gm, "$1- ")
    .replace(/\*\*([^*]+?)\*\*/g, "$1")
    .replace(/__([^_]+?)__/g, "$1")
    .replace(/(^|[\s(["'])\*(?=\S)([^*\n]*?\S)\*(?=$|[\s).,!?:;"'])/gm, "$1$2")
    .replace(/(^|[\s(["'])_(?=\S)([^_\n]*?\S)_(?=$|[\s).,!?:;"'])/gm, "$1$2")
    .replace(/^#{1,6}[ \t]+/gm, "")
    .replace(/`([^`\n]+)`/g, "$1")
    .replace(/[ \t]*\u2014[ \t]*/g, ", ")
    .replace(/,\s*,/g, ",");
}
